import React, { useState } from 'react';

const GuarantorInformation = ({patientFormData,setPatientFormData,submeet}) => {
  const changeHandler = (e) => {
    setPatientFormData({
      ...patientFormData,
      guarantorInformation: {
        ...patientFormData.guarantorInformation,
        [e.target.name]: e.target.value,
      },
    });
  }

  return (
    <div className="card">
      <div className="header">
        <p className="lead">Guarantor Information</p>
      </div>
      <div className="body">
        <div className="row clearfix">
          <div className="form-group col-lg-6 col-md-6" style={{ marginTop: "10px" }}>
            <label>Is patient also guarantor?</label>
            <br />
            <label className="fancy-radio">
              <input
                data-parsley-errors-container="#error-radio"
                name="isGuarantor"
                required=""
                type="radio"
                value="yes"
                checked={patientFormData.guarantorInformation.isGuarantor === 'yes'}
                onChange={changeHandler}
              />
              <span>
                <i></i>Yes
              </span>
            </label>
            <label className="fancy-radio">
              <input
                name="isGuarantor"
                type="radio"
                value="no"
                checked={patientFormData.guarantorInformation.isGuarantor === 'no'}
                onChange={changeHandler}
              />
              <span>
                <i></i>No
              </span>
            </label>
          </div>
        </div>

        <div className="row clearfix">
          <div className="form-group col-lg-2 col-md-12">
            <label>Name</label>
            <input
              className={`form-control ${patientFormData.guarantorInformation.patientName === '' && submeet && 'parsley-error'}`}
              value={patientFormData.guarantorInformation.patientName}
              name="patientName"
              required=""
              onChange={changeHandler}
            />
            {patientFormData.guarantorInformation.patientName === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )}
          </div>

          <div className="form-group col-lg-3 col-md-6">
            <label>Address</label>
            <input
              className={`form-control ${patientFormData.guarantorInformation.patientAddress === '' && submeet && 'parsley-error'}`}
              value={patientFormData.guarantorInformation.patientAddress}
              name="patientAddress"
              required=""
              onChange={changeHandler}
            />
            {patientFormData.guarantorInformation.patientAddress === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )}
          </div>

          <div className="form-group col-lg-2 col-md-6">
            <label>City/State/Zip</label>
            <input
              className={`form-control ${patientFormData.guarantorInformation.patientCity === '' && submeet && 'parsley-error'}`}
              value={patientFormData.guarantorInformation.patientCity}
              name="patientCity"
              required=""
              onChange={changeHandler}
            />
            {patientFormData.guarantorInformation.patientCity === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )}
          </div>

          <div className="form-group col-lg-2 col-md-12">
            <label>Phone</label>
            <input
              className={`form-control ${patientFormData.guarantorInformation.patientPhone === '' && submeet && 'parsley-error'}`}
              value={patientFormData.guarantorInformation.patientPhone}
              name="patientPhone"
              required=""
              onChange={changeHandler}
            />
            {patientFormData.guarantorInformation.patientPhone === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )}
          </div>

          <div className="form-group col-lg-2 col-md-12">
            <label>Relations with Patient</label>
            <input
              className={`form-control ${patientFormData.guarantorInformation.patientRelation === '' && submeet && 'parsley-error'}`}
              value={patientFormData.guarantorInformation.patientRelation}
              name="patientRelation"
              required=""
              onChange={changeHandler}
            />
            {patientFormData.guarantorInformation.patientRelation === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuarantorInformation;